// src/pages/products/components/bulk/ShopMultiSelector.jsx
import React, { useEffect, useState } from 'react';
import { Store, Lock, Check } from 'lucide-react';
import { getShops } from '../../../../services/api/shops';
import styles from './ShopMultiSelector.module.css';

const ShopMultiSelector = ({ selectedShops, onShopsChange, disabled }) => {
  const [shops, setShops] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadShops = async () => {
      try {
        const response = await getShops({ assigned: true });
        setShops(response || []);

        // Auto-select if only one shop
        if (response && response.length === 1 && selectedShops.length === 0) {
          onShopsChange(response);
        }
      } catch (error) {
        console.error('Failed to load shops:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadShops();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isSelected = (shopId) => selectedShops.some(s => s.id === shopId);

  const toggleShop = (shop) => {
    if (disabled) return;
    if (isSelected(shop.id)) {
      onShopsChange(selectedShops.filter(s => s.id !== shop.id));
    } else {
      onShopsChange([...selectedShops, shop]);
    }
  };

  if (isLoading) {
    return (
      <div className={styles.shopSelector}>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <span>Loading shops...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.shopSelector}>
      <div className={styles.sectionHeader}>
        <Store size={20} />
        <h3>Select Shops</h3>
        {disabled && <Lock size={16} className={styles.lockIcon} />}
      </div>

      <div className={styles.shopList}>
        {shops.map(shop => (
          <label
            key={shop.id}
            className={`${styles.shopOption} ${isSelected(shop.id) ? styles.shopOptionSelected : ''} ${disabled ? styles.shopOptionDisabled : ''}`}
          >
            <input
              type="checkbox"
              checked={isSelected(shop.id)}
              onChange={() => toggleShop(shop)}
              disabled={disabled}
              className={styles.checkboxInput}
            />
            <span className={styles.checkboxBox}>
              {isSelected(shop.id) && <Check size={12} />}
            </span>
            <span className={styles.shopName}>{shop.name}</span>
            <span className={styles.shopType}>{shop.type}</span>
          </label>
        ))}
        {shops.length === 0 && (
          <div className={styles.noShops}>No shops available</div>
        )}
      </div>

      {selectedShops.length > 0 && (
        <div className={styles.selectedCount}>
          {selectedShops.length} shop{selectedShops.length !== 1 ? 's' : ''} selected — the sheet's Price column will be applied to each
        </div>
      )}

      {disabled && (
        <div className={styles.disabledNote}>
          Shops cannot be changed after uploading file
        </div>
      )}
    </div>
  );
};

export default ShopMultiSelector;
